mutation DeleteCountryAccesses($ids: [ID!]!) {
  deleteCountryAccesses(ids: $ids) {
    id
  }
}
